module.exports = __webpack_public_path__ + "static/execute-8334a7a630b68b404a293f1799bd3cf1.jpg";